import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.668 2.418a2.25 2.25 0 0 0-2.25 2.25v12.664a2.25 2.25 0 0 0 2.25 2.25h12.666a2.25 2.25 0 0 0 2.251-2.25V4.667a2.25 2.25 0 0 0-2.25-2.25zm-3.75 2.25a3.75 3.75 0 0 1 3.75-3.75h12.667a3.75 3.75 0 0 1 3.75 3.75v12.664a3.75 3.75 0 0 1-3.751 3.75H4.668a3.75 3.75 0 0 1-3.75-3.75zm10.083 1.583a.75.75 0 0 1 .75.75v7.998a.75.75 0 0 1-1.5 0V7.001a.75.75 0 0 1 .75-.75m4 2.999a.75.75 0 0 1 .75.75v4.999a.75.75 0 0 1-1.5 0V10a.75.75 0 0 1 .75-.75m-8 2.333a.75.75 0 0 1 .75.75v2.666a.75.75 0 0 1-1.5 0v-2.666a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }